<template>
  <div class="modal fade" id="ipManagementModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title text-white">
            <i class="mdi mdi-ip-network me-2"></i>
            IP Access Control Management
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <!-- IP Statistics -->
          <div class="row mb-4">
            <div class="col-md-4">
              <div class="card border-success">
                <div class="card-body text-center">
                  <h2 class="text-success mb-0">{{ whitelistedCount }}</h2>
                  <p class="text-muted mb-0">Whitelisted IPs</p>
                  <small class="text-success">All Authorized</small>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card border-info">
                <div class="card-body text-center">
                  <h2 class="text-info mb-0">0</h2>
                  <p class="text-muted mb-0">Blocked Today</p>
                  <small class="text-success">No Threats</small>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card border-success">
                <div class="card-body text-center">
                  <h2 class="text-success mb-0">100%</h2>
                  <p class="text-muted mb-0">Success Rate</p>
                  <small class="text-success">All Clean</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Add IP Form -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-light">
                  <h6 class="mb-0">Add Trusted IP Address</h6>
                </div>
                <div class="card-body">
                  <form @submit.prevent="addIpAddress">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">IP Address</label>
                          <input v-model="newIp.address" type="text" class="form-control"
                                 placeholder="192.168.1.1" required>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Description</label>
                          <input v-model="newIp.description" type="text" class="form-control"
                                 placeholder="Admin IP" required>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="mb-3">
                          <label class="form-label">Type</label>
                          <select v-model="newIp.type" class="form-select" required>
                            <option value="whitelist">Whitelist (Trusted)</option>
                            <option value="monitoring">Monitoring Only</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <button type="submit" class="btn btn-success">
                      <i class="mdi mdi-plus me-1"></i>
                      Add IP Address
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <!-- IP Lists Tabs -->
          <div class="row">
            <div class="col-12">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" data-bs-toggle="tab" href="#whitelisted-tab">
                    <i class="mdi mdi-shield-check me-1"></i>
                    Whitelisted IPs ({{ whitelistedIps.length }})
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#monitoring-tab">
                    <i class="mdi mdi-eye me-1"></i>
                    Monitoring ({{ monitoringIps.length }})
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#activity-tab">
                    <i class="mdi mdi-history me-1"></i>
                    Recent Activity
                  </a>
                </li>
              </ul>

              <div class="tab-content p-3 border border-top-0">
                <!-- Whitelisted IPs Tab -->
                <div class="tab-pane fade show active" id="whitelisted-tab">
                  <div class="table-responsive">
                    <table class="table table-sm table-hover">
                      <thead>
                      <tr>
                        <th>IP Address</th>
                        <th>Description</th>
                        <th>Added Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(ip, index) in whitelistedIps" :key="index">
                        <td>
                          <strong>{{ ip.address }}</strong>
                        </td>
                        <td>{{ ip.description }}</td>
                        <td>{{ ip.addedDate }}</td>
                        <td>
                            <span class="badge bg-success">
                              <i class="mdi mdi-check-circle me-1"></i>
                              Active
                            </span>
                        </td>
                        <td>
                          <button @click="editIp(ip)" class="btn btn-sm btn-outline-primary me-1">
                            <i class="mdi mdi-pencil"></i>
                          </button>
                          <button @click="removeIp(ip)" class="btn btn-sm btn-outline-danger">
                            <i class="mdi mdi-delete"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Monitoring Tab -->
                <div class="tab-pane fade" id="monitoring-tab">
                  <div class="table-responsive">
                    <table class="table table-sm table-hover">
                      <thead>
                      <tr>
                        <th>IP Address</th>
                        <th>Last Seen</th>
                        <th>Requests Today</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(ip, index) in monitoringIps" :key="index">
                        <td>
                          <strong>{{ ip.address }}</strong>
                        </td>
                        <td>{{ ip.lastSeen }}</td>
                        <td>
                          <span class="badge bg-info">{{ ip.requestsToday }}</span>
                        </td>
                        <td>
                          <span class="badge bg-success">Normal</span>
                        </td>
                        <td>
                          <button @click="whitelistIp(ip)" class="btn btn-sm btn-outline-success">
                            <i class="mdi mdi-shield-check"></i>
                            Whitelist
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Activity Tab -->
                <div class="tab-pane fade" id="activity-tab">
                  <div class="activity-log" style="max-height: 300px; overflow-y: auto;">
                    <div v-for="(activity, index) in recentActivity" :key="index"
                         class="activity-item p-2 border-bottom">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{{ activity.ip }}</strong>
                          <span class="badge bg-success ms-2">{{ activity.action }}</span>
                          <p class="mb-0 text-muted small">{{ activity.description }}</p>
                        </div>
                        <small class="text-muted">{{ activity.time }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="exportIpList" class="btn btn-outline-primary">
            <i class="mdi mdi-file-export me-1"></i>
            Export IP List
          </button>
          <button @click="saveChanges" class="btn btn-success">
            <i class="mdi mdi-content-save me-1"></i>
            Save Changes
          </button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'IpManagementModal',
  props: {
    ipLists: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      newIp: {
        address: '',
        description: '',
        type: 'whitelist'
      },
      whitelistedCount: 45,
      whitelistedIps: [
        {
          address: '192.168.1.10',
          description: 'Admin Workstation',
          addedDate: '2025-01-10',
          status: 'active'
        },
        {
          address: '10.0.0.150',
          description: 'Internal Server',
          addedDate: '2025-01-08',
          status: 'active'
        },
        {
          address: '172.16.0.45',
          description: 'Backup Server',
          addedDate: '2025-01-05',
          status: 'active'
        },
        {
          address: '192.168.1.25',
          description: 'Developer Machine',
          addedDate: '2025-01-03',
          status: 'active'
        }
      ],
      monitoringIps: [
        {
          address: '203.0.113.45',
          lastSeen: '10 minutes ago',
          requestsToday: 156
        },
        {
          address: '198.51.100.23',
          lastSeen: '25 minutes ago',
          requestsToday: 89
        }
      ],
      recentActivity: [
        {
          ip: '192.168.1.10',
          action: 'ALLOWED',
          description: 'Successful authentication',
          time: '5 minutes ago'
        },
        {
          ip: '10.0.0.150',
          action: 'ALLOWED',
          description: 'API request processed',
          time: '10 minutes ago'
        },
        {
          ip: '172.16.0.45',
          action: 'ALLOWED',
          description: 'Backup operation completed',
          time: '15 minutes ago'
        },
        {
          ip: '192.168.1.25',
          action: 'ALLOWED',
          description: 'Database query executed',
          time: '20 minutes ago'
        }
      ]
    }
  },
  methods: {
    addIpAddress() {
      if (this.newIp.address && this.newIp.description) {
        const newEntry = {
          address: this.newIp.address,
          description: this.newIp.description,
          addedDate: new Date().toISOString().split('T')[0],
          status: 'active'
        };

        if (this.newIp.type === 'whitelist') {
          this.whitelistedIps.unshift(newEntry);
          this.whitelistedCount++;
        } else {
          this.monitoringIps.unshift({
            address: this.newIp.address,
            lastSeen: 'Just now',
            requestsToday: 0
          });
        }

        // Reset form
        this.newIp = {
          address: '',
          description: '',
          type: 'whitelist'
        };

        // Add to activity
        this.recentActivity.unshift({
          ip: newEntry.address,
          action: 'ADDED',
          description: `IP address added to ${this.newIp.type}`,
          time: 'Just now'
        });
      }
    },

    editIp(ip) {
      // Implementation for editing IP
      console.log('Edit IP:', ip);
    },

    removeIp(ip) {
      const index = this.whitelistedIps.findIndex(item => item.address === ip.address);
      if (index > -1) {
        this.whitelistedIps.splice(index, 1);
        this.whitelistedCount--;
      }
    },

    whitelistIp(ip) {
      const newEntry = {
        address: ip.address,
        description: 'Promoted from monitoring',
        addedDate: new Date().toISOString().split('T')[0],
        status: 'active'
      };

      this.whitelistedIps.unshift(newEntry);
      this.whitelistedCount++;

      // Remove from monitoring
      const index = this.monitoringIps.findIndex(item => item.address === ip.address);
      if (index > -1) {
        this.monitoringIps.splice(index, 1);
      }
    },

    exportIpList() {
      const data = {
        whitelisted: this.whitelistedIps,
        monitoring: this.monitoringIps,
        exportDate: new Date().toISOString()
      };

      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'ip-access-control-list.json';
      a.click();
      URL.revokeObjectURL(url);
    },

    saveChanges() {
      this.$emit('ip-updated', {
        whitelisted: this.whitelistedCount,
        blacklisted: 0
      });

      // Close modal
      const modalElement = document.getElementById('ipManagementModal');
      if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement);
        if (modal) {
          modal.hide();
        }
      }
    }
  }
}
</script>

<style scoped>
.activity-item {
  transition: background-color 0.2s ease;
}

.activity-item:hover {
  background-color: #f8f9fa;
}

.nav-tabs .nav-link {
  color: #495057;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.modal-header.bg-primary {
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%) !important;
}
</style>